<template>
  <div>
    <fn-section
      constrained="l"
      padding-top="s"
      padding-bottom="s"
      :background-color="backgroundColor"
    >
      <fn-breadcrumbs :nodes="page.content.breadcrumbs" />
    </fn-section>

    <fn-cms-section-loader
      v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
      :sections="page.content.content_slots.a.sections"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  page: Record<string, any>;
  backgroundColor?: string;
}>();

const route = useRoute();
useScrollToHash(route);
</script>
